import { render, staticRenderFns } from "./QuoteHeader.vue?vue&type=template&id=342cfed2&scoped=true"
import script from "./QuoteHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./QuoteHeader.vue?vue&type=script&setup=true&lang=js"
import style0 from "./QuoteHeader.vue?vue&type=style&index=0&id=342cfed2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342cfed2",
  null
  
)

export default component.exports